
  import { createRoot } from "react-dom/client";
  import * as Sentry from "@sentry/react";
  import { ErrorBoundary } from "./app/components/ErrorBoundary";
  import App from "./app/App.tsx";
  import "./styles/index.css";

  // Initialize Sentry error monitoring (no-op if DSN not configured)
  const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
  if (sentryDsn) {
    Sentry.init({
      dsn: sentryDsn,
      environment: import.meta.env.MODE,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 0.2,
    });
  }

  // Catch unhandled promise rejections not caught by ErrorBoundary
  globalThis.addEventListener("unhandledrejection", (event) => {
    console.error("Unhandled rejection:", event.reason);
    if (sentryDsn) Sentry.captureException(event.reason);
  });

  createRoot(document.getElementById("root")!).render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );

